import React, { useEffect, useRef, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './SmartbookAI.module.css';
import VideoComponent from './Seccion1/S1'; // Import the new VideoComponent

//Importación de videos
import video1 from './video/video1.mp4';
import video2 from './video/video2.mp4';
import video3 from './video/video3.mp4';

//Importación de imágenes
import image1 from './video/smartbook.png';
import image2 from './video/agendador.jpg';
import image3 from './video/clones.jpg';
import image4 from './video/chat.jpg';
import image5 from './video/calificador.jpg';

const SmartbookAI = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
        window.scrollTo(0, 0);  // Aquí se asegura de que la página empiece desde arriba
    }, []);

    const [start, setStart] = useState(true);
    const [end, setEnd] = useState(false);
    const sliderRef = useRef(null);

    const handleScroll = () => {
        if (sliderRef.current.scrollLeft === 0) {
            setStart(true);
        } else {
            setStart(false);
        }

        if (Math.abs((sliderRef.current.scrollWidth - sliderRef.current.offsetWidth) - sliderRef.current.scrollLeft) < 5) {
            setEnd(true);
        } else {
            setEnd(false);
        }
    };

    const videoData = [
        { videoSrc: video1, title: "Profesionales", description: "La IA ofrece herramientas poderosas a los profesionales independientes, optimizando tareas y mejorando la atención al cliente." },
        { videoSrc: video2, title: "Empresas", description: "La IA transforma empresas al automatizar operaciones y analizar grandes volúmenes de datos para tomar decisiones informadas." },
        { videoSrc: video3, title: "Tecnología", description: "La IA potencia los departamentos de tecnología optimizando la gestión de redes y mejorando la seguridad cibernética." },
        { videoSrc: video1, title: "Startups", description: "La IA ofrece ventajas competitivas únicas a las startups, desde la automatización de procesos hasta la personalización de productos." }
    ];

    const productCards = [
        { title: "CALIFICADOR", description: "...", image: image5 },
        { title: "PLATAFORMA PARA PROFESORES", description: "...", image: image1 },
        { title: "AGENDADOR", description: "...", image: image2 },
        { title: "CLONES IA", description: "...", image: image3 },
        { title: "CHAT", description: "...", image: image4 }
    ];

    return (
        <div className={styles.container}>
            <VideoComponent /> {/* Insert the new VideoComponent here */}
            <h1 className={styles.heading} data-aos="fade-up">BENEFICIOS</h1>
            <div className={styles.row}>
                {videoData.map((data, index) => (
                    <div
                        key={index}
                        className={styles.videoTextContainer}
                        data-aos="fade-up"
                        data-aos-delay={`${index * 100}`}
                    >
                        <video className={styles.video} autoPlay playsInline loop muted>
                            <source src={data.videoSrc} type="video/mp4" />
                            Tu navegador no soporta el video.
                        </video>
                        <div className={styles.textContainer}>
                            <h2>{data.title}</h2>
                            <p>{data.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SmartbookAI;
